import React from 'react'
import { Col } from 'reactstrap'

const Team = () => {
  return (
    <div className="increase-p-font1-5">
      <h1>Team Edition</h1>
      <Col>
        <div>
          <p>Working with a team doesn&#39;t need to be like herding cats.</p>
          <p>What if the entire team was working toward the same core priorities.
            With a common set of strategies. And each member would set their own goals toward those strategies.
          </p>
          <p>As they progress, they record journal entries showing progress toward their goals.</p>
          <p>You can then report on team progress grouped by priority or strategy for
            the time period of interest.
          </p>
          <p>The beauty of Team Edition is it&#39;s simplicity to keep the team aligned
            while making communication and reporting easy.
          </p>
          <div>
            <h2>How It Works</h2>
            <ul>
              <li><p>First, identify your team&#39;s core priorities.</p></li>
              <li><p>Second, create one or more strategies to fulfill each priority.</p></li>
              <li><p>Third, invite team members.</p></li>
              <li><p>Fourth, have each member set goals for each strategy.</p></li>
              <li><p>Then, simply journal progress as each member works toward goals.</p></li>
            </ul>
            <p>Then you will all be able to see what is being accomplished to move toward
              the team priorities. You can <b>follow</b> goals or strategies as well as <b>mention</b> team members.
            </p>
            <p>In addition, you can have <b>comment threads</b> to discuss and share ideas as you journal progress.
            </p>
          </div>
        </div>
      </Col>
    </div>
  )
}

export default Team
